import { connect } from 'react-redux'
import {
  getFormats,
  setModalFormatOpen,
  setInputDataFormat,
  setIsEditFormat,
  setCurrentDataForEdit,
  resetInputData,
} from 'reduxpath/ducks/Format/List'

import {
  setFormat,
} from 'reduxpath/ducks/Format/Add'

import {
  updateFormat,
  setSelectedIdFormat,
} from 'reduxpath/ducks/Format/Edit'

import {
  setIsDeleteSubCategoryModalOpen,
  setSelectedFormatId,
} from 'reduxpath/ducks/Format/Remove'

import ServiceSubCategory from './units'

const mapStateToProps = state => ({
  formatList: state.FormatList.data,
  isModalFormatOpen: state.FormatList.isModalFormatOpen,
  serviceSelections: state.FormatList.serviceSelections,
  inputData: state.FormatList.inputData,
  isEditFormat: state.FormatList.isEditFormat,
  selectedIdFormat: state.FormatEdit.selectedIdFormat,
  user: state.Auth.me.user,
})

const mapDispatchToProps = dispatch => ({
  handlePageChange(key) {
    const limit = 10
    const qs = {
      sort: 'createdAt ASC',
      limit,
      skip: key.selected * limit,
    }
    dispatch(getFormats(qs))
  },

  openModalFormat(data) {
    return () => {
      dispatch(setIsEditFormat(false))
      dispatch(setModalFormatOpen(data))
      dispatch(resetInputData())
    }
  },

  setInputDataFormat(field) {
    return (e) => {
      let inputValue = e.target.value
      if (field === 'isSearchable' || field === 'isUsable') {
        inputValue = e.target.checked
      }
      const data = {
        field,
        value: inputValue,
      }
      dispatch(setInputDataFormat(data))
    }
  },

  addNewDataFormat(data) {
    return () => {
      dispatch(setFormat(data, () => {
        const qs = {
          sort: 'createdAt ASC',
          limit: 10,
          skip: 0,
        }
        dispatch(setModalFormatOpen(false))
        dispatch(getFormats(qs))
        dispatch(resetInputData())
      }))
    }
  },

  onEditClick(data) {
    return () => {
      const inputData = {
        service: data.service.id,
        name: data.name,
        description: data.description,
        isUsable: data.isUsable,
        isSearchable: data.isSearchable,
      }

      dispatch(setIsEditFormat(true))
      dispatch(setModalFormatOpen(true))
      dispatch(setCurrentDataForEdit(inputData))
      dispatch(setSelectedIdFormat(data.id))
    }
  },

  updateDataFormat(data, id) {
    return () => {
      dispatch(updateFormat(data, id, () => {
        const qs = {
          sort: 'createdAt ASC',
          limit: 10,
          skip: 0,
        }
        dispatch(setModalFormatOpen(false))
        dispatch(getFormats(qs))
        dispatch(setIsEditFormat(false))
        dispatch(resetInputData())
      }))
    }
  },

  setIsDeleteSubCategoryModalOpen(data, id) {
    return () => {
      dispatch(setIsDeleteSubCategoryModalOpen(data))
      dispatch(setSelectedFormatId(id))
    }
  },
})

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  addNewDataFormat: dispatchProps.addNewDataFormat(stateProps.inputData),
  updateDataFormat: dispatchProps.updateDataFormat(
    stateProps.inputData,
    stateProps.selectedIdFormat,
  ),
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ServiceSubCategory)
